<template>
  <div class="ma-4">
    <ClientNav/>
    <v-row dense>
      <v-col cols="12">
        <v-card height="100%">
          <v-toolbar color="primary" dark>{{ titleForm }}</v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-row class="mt-3">
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="newOpenDate"
                      label="Investigation Start Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newOpenDate"
                    :active-picker.sync="activePicker"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="mt-1">
              <v-col
                class="d-flex"
                cols="12"
                sm="12"
              >
                <v-select
                  :items="category"
                  label="Category"
                  outlined
                  v-model="newCategory"
                ></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  label="Investigation Description"
                  v-model="newDescription"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-file-input
                  chips
                  show-size
                  class="pa-2"
                  label="Select mp3 or mp4 to upload"
                  filled
                  multiple
                  prepend-icon="mdi-play-circle-outline"
                  accept="audio/mp3, video/mp4, video/x-m4v, video/*"
                  @change="selectAttachment"
                ></v-file-input>


                <div v-for="attachment in investigationAttachment" :key="attachment">
                  <video v-if="isVideo(attachment)" width="320" height="240" controls>
                    <source :src="attachment" :type="getMimeType(attachment)">
                    Your browser does not support the video tag.
                  </video>
                  <audio v-else controls>
                    <source :src="attachment" :type="getMimeType(attachment)">
                    Your browser does not support the audio tag.
                  </audio>
                </div>
              </v-col>

            </v-row>

            <v-row class="mt-n8">
              <v-col cols="12" md="12">
                <v-checkbox
                  label="Opened By"
                  hide-details
                  @change="addSignature($event)"
                  v-model="checkedSignature"
                ></v-checkbox>
                <v-text-field v-model="newSignature"></v-text-field>
              </v-col>
              <v-col cols="12" md="12" v-if="closedBySignature">
                <v-checkbox
                  label="Closed By"
                  hide-details
                  v-model="checkedClosedBySignature"
                  readonly
                ></v-checkbox>
                <v-text-field v-model="closedBySignature" disabled></v-text-field>
              </v-col>

              <v-col cols="12" md="12" v-if="closedBySignature">
                <v-datetime-picker
                  label="Close Date"
                  v-model="closedDate"
                  prepend-icon="mdi-calendar"
                />
              </v-col>

            </v-row>
          </v-card-text>

          <v-card-actions>
            <div class="ml-5" v-show="!createInvestigation && !isAuditorRole">
              <v-switch
                inset
                v-model="CloseOut"
                label="Closeout"
                @change="addCloseBySignature"
              ></v-switch>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              fab
              small
              @click="showPrint()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="!createInvestigation"
            >
              <v-icon>print</v-icon>
            </v-btn>

            <v-btn
              v-if="!isAuditorRole"
              size="large"
              :disabled="disabled"
              class="white--text"
              :color="updateInvestigation ? 'blue darken-1' : '#259647'"
              @click="!createInvestigation ? updateInvestigation() : addInvestigation()"
            >
              <div class="text-caption text-sm-body-1">
                {{ !createInvestigation ? "Update" : "Save" }}
              </div>
            </v-btn>
            <v-btn color="blue darken-1" text @click="close">
              <div class="text-caption text-sm-body-1">
                Cancel
              </div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import {mapMutations} from "vuex"
import moment from "moment";
import {displaySuccess, displayError, displayInfo} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

export default {
  components: {
    ClientNav,
    Foot,
  },
  data: function () {
    return {
      closedDate: '',
      isLoading: false,
      signed: false,
      transactionDialog: false,
      msg: false,
      search: "",
      text: "",
      investigations: [],
      investigation: {},
      clientID: this.$route.params.clientID,
      investigationId: this.$route.params.id,
      token: localStorage.getItem('token'),
      userID: "",
      tempData: [],
      titleForm: "New Investigation",
      investigationID: "",
      newOpenDate: "",
      newEntity: "",
      newInvolved: "",
      newClient: "",
      newStaff: "",
      newDescription: "",
      newStaffSignature: "",
      newSignature: "",
      closedBySignature: "",
      uploadImg: "",
      staff: localStorage.getItem("Name"),
      involve: [
        "Staff",
        "Client"
      ],
      employees: [],
      clients: [],
      userState: localStorage.getItem('userState'),
      admin: false,
      menu: false,
      disabled: false,
      CloseOut: false,
      activePicker: null,
      checkedSignature: false,
      checkedClosedBySignature: false,
      category: ["Inconclusive Allegation", "Substantiated Allegation", "Unsubstantiated Allegation",],
      newCategory: "",
      createInvestigation: false,
      investigationAttachment: [],
    };
  },

  mounted() {
    if (!this.createInvestigation) {
      this.getInvestigation();
    }

    window.addEventListener('keydown', async (event) => {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.handleKeydown(event, downloadUrl, this.investigationId, this.token, 'Investigation');
    });
  },

  beforeDestroy() {
    window.removeEventListener('keydown', (event) => {
      PrintUtil.handleKeydown(event, this.downloadUrl, this.investigationId, this.token, 'Investigation');
    });
  },

  computed: {
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {},

  created() {
    this.createInvestigation = this.$route.query.createInvestigation === 'true';
    this.userID = localStorage.getItem("userID");
    if (localStorage.getItem('userRole') === "Administration") {
      this.admin = true;
    }
    this.getEmployees();
    this.getClients()
  },

  methods: {

    ...mapMutations({
      setCloseOut: "investigations/SET_CLOSEOUT",
    }),

    getEmployees() {
      axios.get(`${url}/users/state/${this.userState}`).then(res => {
        this.employees = res.data.users;

      });
    },

    getClients() {
      axios.get(`${url}/clients/state/${this.userState}`).then(async (res) => {
        this.clients = res.data.clients;
      });
    },

    initialize() {
      this.investigations = [];
    },

    viewInvestigation(item, documents) {
      if (item.StaffSignature !== "") {
        this.checkedSignature = true;
      }

      if (item.ClosedbySignature !== "") {
        this.checkedClosedBySignature = true;
      }
      this.titleForm = "Update Investigation";
      this.newOpenDate = moment(item.OpenDate).format('YYYY-MM-DD');
      this.closedDate = new Date(item.ClosedDate)
      this.newInvolved = item.Involved;
      this.newCategory = item.Category;
      this.newDescription = item.Description;
      this.newSignature = item.StaffSignature;
      this.closedBySignature = item.ClosedbySignature;
      this.newClient = item.ClientID;
      this.newStaff = item.StaffID;
      this.CloseOut = item.CloseOut;
      this.investigationID = item._id;
      this.investigationAttachment = documents.map(doc => doc.AWSLink);
    },

    clear() {
      this.newOpenDate = "";
      this.newInvolved = "";
      this.newDescription = "";
      this.newStaffSignature = "";
      this.newClient = "";
      this.newStaff = "";
      this.newCategory = ""
      this.editInvestigation = false
      this.CloseOut = false;
    },

    close() {
      this.$router.go(-1);
      this.clear();
    },

    getInvestigation() {
      axios.get(`${url}/investigations/${this.clientID}/investigation/${this.investigationId}`).then(res => {
        this.investigation = res.data.investigation
        let documents = res.data.documents
        this.viewInvestigation(this.investigation, documents);

      })
    },

    getInvestigations() {
      axios.get(`${url}/investigations/${this.clientID}`).then(res => {
        this.investigations = res.data.investigations.map(item => {
          return {
            ...item,
            OpenDate: moment(item.OpenDate).format('YYYY-MM-DD'),
            ClosedDate: item?.ClosedDate ? moment(item.ClosedDate).format('YYYY-MM-DD hh:mm A') : '',
          }
        })

      })
    },

    async addInvestigation() {
      let req_body = {
        OpenDate: this.newOpenDate,
        Entity: this.newEntity,
        Involved: this.newInvolved,
        Description: this.newDescription,
        StaffSignature: this.newSignature,
        Category: this.newCategory,
        ClientID: this.clientID,
        ClosedDate: this.closedDate
        //  StaffID: this.newStaff,
      }

      try {

        const response = await axios.post(`${url}/investigations`, req_body);
        console.log({response});
        this.investigationID = response.data.investigations._id;
        console.log({investigationResponse: this.investigationID});

        if (response.status !== 200) {
          displayError("There was an error adding the document.");
          return;
        }

        if (this.investigationAttachment && this.investigationAttachment.length) {
          displayInfo("Please wait, the file is still uploading.")
          await this.uploadAttachments(this.investigationAttachment);
        }

        displaySuccess("Investigation and uploading of file added successfully");
        this.getInvestigations();
        this.clear();


      } catch (error) {
        displayError("Failed to upload file: " + (error.response && error.response.data && error.response.data.msg || "An unexpected error occurred."));
      } finally {
        this.isSavingImage = false;
        this.isLoading = false;
        this.close();
      }
    },

    selectAttachment(investigationAttachment) {
      this.investigationAttachment = investigationAttachment;
    },

    async uploadAttachments(files) {

      const formData = new FormData();
      formData.append('clientId', this.clientID);
      formData.append('investigationID', this.investigationID);

      for (let file of files) {
        formData.append('investigation-file', file);
      }

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      try {
        const response = await axios.post(`${url}/investigations/attachment/upload/${this.investigationID}/${this.clientID}`, formData, config);
        console.log({response});
      } catch (error) {
        console.error("Upload Error: ", error.response.data);
      }
    },

    async updateInvestigation() {
      let req_body = {
        OpenDate: this.newOpenDate,
        Entity: this.newEntity,
        Involved: this.newInvolved,
        Description: this.newDescription,
        StaffSignature: this.newSignature,
        ClientID: this.newClient,
        Category: this.newCategory,
        CloseOut: this.CloseOut,
        ClosedbySignature: this.closedBySignature,
        ClosedDate: this.closedDate
        //  StaffID: this.newStaff,
      }

      try {
        const response = await axios.put(`${url}/investigations/${this.investigationId}`, req_body)

        if (this.investigationAttachment && this.investigationAttachment.length) {
          displayInfo("Please wait, the file is still uploading.")
          await this.uploadAttachments(this.investigationAttachment);
        }

        if (response.status === 200) {
          displaySuccess('Investigation updated successfully');
          this.getInvestigations();
        } else {
          displayError('Failed to update investigation');
        }

      } catch (error) {
        console.log(error)
      } finally {
        this.close();
      }
    },

    addSignature(e) {
      if (!e) return (this.newSignature = "");
      this.newSignature = this.staff + " - " + new Date();
      this.signed = true;
    },

    addCloseBySignature(e) {
      if (!e) return (this.closedBySignature = "", this.closedDate = "");
      this.closedBySignature = this.staff + " - " + new Date();
      this.signed = true;
      this.closedDate = null
    },

    async generateDownloadUrl() {
      return `${url}/investigations/print?id=${this.investigationId}`;
    },

    async showPrint() {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.showPrintOption(downloadUrl, this.investigationId, this.token, 'Investigation');
    },

    isVideo(url) {
      return url.match(/\.(mp4|m4v)$/i) != null;
    },

    getMimeType(url) {
      if (url.match(/\.mp3$/i)) {
        return "audio/mpeg";
      } else if (url.match(/\.mp4$/i)) {
        return "video/mp4";
      } else if (url.match(/\.m4v$/i)) {
        return "video/x-m4v";
      } else {
        return "video/*";
      }
    }


  },
};
</script>
<style>
.Red {
  background-color: #ffebee;
}

.Green {
  background-color: #e8f5e9;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

.balance-amount {
  font-size: 40px;
}

.balance-amount--current {
  font-size: 20px;
}
</style>
